import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/despre-noi/")({
  head: () => routeHead("/de/despre-noi/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <About />
  );
}
